import type { Appointment } from "@medplum/fhirtypes";
import { EXTERNAL_REFERENCE_IDENTIFIER_PREFIX } from "@/models/base/external-reference";

export const EXTERNAL_APPOINTMENT_IDENTIFIER_PREFIX = EXTERNAL_REFERENCE_IDENTIFIER_PREFIX;

export const EXTERNAL_APPOINTMENT_SOURCE_LABELS: Record<string, string> = {
  boulevard: "Boulevard",
};

/** Only the appointment's own identifiers establish ownership. Participant identifiers do not. */
export function getExternalSource(resource: Appointment): string | undefined {
  const identifier = resource.identifier?.find((entry) =>
    entry.system?.startsWith(EXTERNAL_APPOINTMENT_IDENTIFIER_PREFIX),
  );
  return identifier?.system?.slice(EXTERNAL_APPOINTMENT_IDENTIFIER_PREFIX.length);
}

export function getExternalSourceLabel(source: string): string {
  return Object.hasOwn(EXTERNAL_APPOINTMENT_SOURCE_LABELS, source)
    ? EXTERNAL_APPOINTMENT_SOURCE_LABELS[source]
    : "External system";
}

export interface ExternalAppointmentDetails {
  services: string[];
  staff: string[];
  locations: string[];
}

/** Keep service, staff, and location displays separate. FHIR has no link between them. */
export function getExternalAppointmentDetails(resource: Appointment): ExternalAppointmentDetails {
  const participants = resource.participant ?? [];
  const displaysForType = (code: string): string[] =>
    participants
      .filter((participant) =>
        participant.type?.some((type) => type.coding?.some((coding) => coding.code === code)),
      )
      .flatMap((participant) => (participant.actor?.display ? [participant.actor.display] : []));

  return {
    services:
      resource.serviceType?.flatMap((service) => (service.text ? [service.text] : [])) ?? [],
    staff: displaysForType("PPRF"),
    locations: displaysForType("LOC"),
  };
}
